<template>
  <div class="RwvContentSlider">
    <b-form-group
      v-if="data.slides.length > 12"
      :id="'input-group-jumpTo-' + index"
      label="Springe zu"
      :label-for="'input-group-jumpTo-' + index"
      >
    <b-form-input
        :id="'input-jumpTo-' + index"
        v-model="pageIndex"
        type="number"
        required
        placeholder="Site"
      ></b-form-input>
    </b-form-group>

    <b-carousel
      :id="'carousel-' + index"
      :interval="data.interval"
      v-model="pageIndex"
      controls
      :indicators="true"
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333;"
    >

      <b-carousel-slide
        v-for="(slide, page) in data.slides"
        :key="page+1"
        :caption="slide.caption"
        :text="slide.text"
        :img-src="slide.image"
      ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "RwvContentEmbed",
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      pageIndex: 0
    }
  }
};
</script>
<style lang="scss">
  .carousel-caption p, .carousel-caption h3, .carousel-control-next:hover, .carousel-control-prev:hover {
    background-color: rgba(55,55,55,0.2);
    border-radius: 3px;
  }
</style>
